module.exports = __webpack_public_path__ + "img/noimage.abb2d528.jpeg";